import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'
import { NavLink } from "react-router-dom";

export default function AlertCredit() {
  return (
    <div className="border-l-4 border-yellow-400 bg-yellow-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            You do not have sufficient credits.{' '}
            <NavLink to="/cart" className="font-medium text-yellow-700 underline hover:text-yellow-600">
            Please add credits to create a book!<span aria-hidden="true">→</span>
            </NavLink>
          </p>
        </div>
       
      </div>
    </div>
  )
}
